import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import UseStyles from "./UseStyles";
import useAPIError from "../../APIError";
import moment from "moment";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import CircularProgress from "@material-ui/core/CircularProgress";
import SaveIcon from "@material-ui/icons/Save";
import TextField from "@material-ui/core/TextField";
import CloudUpload from "@material-ui/icons/CloudUpload";
import Utils from "../../Utils";
import IconButton from "@material-ui/core/IconButton";
import GetAppIcon from "@material-ui/icons/GetApp";
import { DocsDataAPI } from "../../API/DocsDataAPI";
import { ApplicationDataAPI } from '../../API/ApplicationDataAPI';
import { RfiDataAPI } from '../../API/RfiDataAPI';
import { AttachmentRepo } from "../../../../repositories";


function RfiItem({ rfi, onRfiSaved, app, documents, setRefresh }) {
	const { register, handleSubmit, errors } = useForm();
	const [rfiData, setRfiData] = useState(rfi);
	const [selectedFile, setSelectedFile] = useState({});
	const [uploading, setUploading] = useState(false);
	const [downloading, setDownloading] = useState(false);
	const [saving, setSaving] = useState(false);
	const classes = UseStyles();
	const [attachments, setAttachments] = useState([]);
	const [docs, setDocs] = useState([]);
	const { addError } = useAPIError();

	useEffect(() => {
		setRfiData(rfi);
	}, [rfi]);

	useEffect(() => {
		setDocs(documents.filter((item) => item.rfi === rfi.id));
	}, [documents]);

	useEffect(() => {
		(async () => {
			if (rfi.is_done) {
				try {
					setAttachments(await DocsDataAPI.getDocumentAttachment(rfi.id));
				} catch (error) {
					addError(error.message);
				}
			}
		})();

	}, []);

	const handleResolveClick = async () => {
		setSaving(true);
		try {
			rfiData.is_done = true;
			rfiData.resolved_time = new Date();
			await RfiDataAPI.closeRfi(rfiData, "ALL", app.locked_by_email);
			await ApplicationDataAPI.updateApplicationWithAction(app, { action: "unhold" }, "ALL", app.locked_by_email);
			onRfiSaved();
		} catch (e) {
			console.log(e);
			alert("Error while resolving RFI");
		} finally {
			setSaving(false);
		}
	};

	const viewAttachment = async (attachment) => {
		let pdfWindow = window.open("");
		pdfWindow.document.write(
			"<iframe width='100%' height='100%' src='data:" +
			attachment.content_type +
			";base64, " +
			encodeURI(attachment.body) +
			"'></iframe>"
		);
	};

	const onFileSelected = (e) => {
		for (const file of e.target.files) {
			setSelectedFile(file);
		}
	};
	const uploadFile = async () => {
		if (selectedFile) {
			try {
				setUploading(true);
				// NEW CODE TO UPLOAD DOCUMENT
				DocsDataAPI.uploadDocumentToFileStore(
					app.id,
					app.broker_id,
					selectedFile,
					"RFI Document",
					rfi.id,
					app.locked_by_name,
					null,
					null,
					null,
					app.locked_by_email,
					null
				).then(() => {
					onRfiSaved();
					setRefresh(true);
				});

				setSelectedFile({});
				document.getElementById("container_file_uploader").value = null;
			} catch (e) {
				console.log(e);
			} finally {
				setUploading(false);
			}
		}
	};

	const downloadFileStoreFile = async (azure_file_url, document_name, containerType) => {
		//Call the FileStore micro service to get the file URL.
		const fileData = await AttachmentRepo.getFileStoreURL(
			azure_file_url,
			containerType,
			app.broker_id
		);
		// Create anchor/link HTML element with href to click/download file.
		const link = document.createElement('a');
		// Create href link for file data retrieve from FileStore. 
		link.href = URL.createObjectURL(fileData);
		// Set the file name
		link.setAttribute('download', `${document_name}`);
		document.body.appendChild(link);
		// Initiate the download
		link.click();
		// Clean up the link.
		document.body.removeChild(link);
	  };

	const downloadFile = async (documentId, azure_file_url, document_name) => {
		try {
			setDownloading(true);
			const containerType = "applications";
			if (azure_file_url !== undefined) {
				downloadFileStoreFile(azure_file_url, document_name, containerType);
			} else {
				let attachments = await DocsDataAPI.getDocumentAttachment(documentId);
				if (attachments.length > 0) {
					let blob = Utils.base64ToBlob(
						attachments[0].body,
						attachments[0].content_type
					);
					let link = Utils.blobToLink(blob, attachments[0].name);
					link.click();
					window.URL.revokeObjectURL(link.href);
					link.remove();
				}
			}
		} catch (e) {
			console.log(e);
			alert("Failed to download file");
		} finally {
			setDownloading(false);
		}
	};

	return (
		<Grid
			container
			spacing={1}
			className={
				rfi.rfi_status === "Closed"
					? classes.resolved_rfi
					: rfi.rfi_status === "Responded"
						? classes.responded_rfi
						: classes.pending_rfi
			}>
			<Grid item xs={6}>
				{rfi.rfi_status === "Closed" ? (
					<div className={classes.corner_text}>Closed</div>
				) : rfi.rfi_status === "Responded" ? (
					<div className={classes.corner_text}>Responded</div>
				) : (
					<div className={classes.corner_text}>Pending</div>
				)}
				<strong>RFI Request </strong> @{" "}
				{moment(rfi.request_date).format("MMMM Do YYYY, h:mm a")}
				<br />
				<strong>Request By </strong> {rfi.created_by}
				<br />
				<strong>Reason</strong> {rfi.rfi_reason}
				<br />
				<strong>Detail</strong> {rfi.detail}
				<br />
				{rfi.responded_by_name && (
					<>
						<br />
						<strong>Responded By </strong> {rfi.responded_by_name}
						<br />
					</>
				)}
				{rfi.broker_comment && (
					<>
						<strong>Responded Time </strong> Field yet to be created in API
						<br />
					</>
				)}
				{rfi.broker_comment && (
					<>
						<strong>Broker Comment </strong> {rfi.broker_comment}
						<br />
					</>
				)}
				<br />
				{docs.length > 0 &&
					docs.map((doc, index) => (
						<>
							{downloading ? (
								<CircularProgress size={20} />
							) : (
								<IconButton
									disabled={downloading}
									aria-label="download"
									onClick={(event) => {
										downloadFile(doc.id, doc.azure_file_url, doc.document_name);
									}}>
									<GetAppIcon />
								</IconButton>
							)}
							{doc.document_name}
							<br />
						</>
					))}
				<br />
			</Grid>
			{rfi.rfi_status === "Closed" ? (
				<Grid item xs={6}>
					<strong>Closed By </strong> {rfi.resolved_by_name}
					<br />
					<strong>Closed Time </strong>{" "}
					{moment(rfi.resolved_time).format("MMMM Do YYYY, h:mm a")}
					<br />
					<strong>Closed Detail </strong> {rfi.closing_comment}
					<br />
					{attachments.length > 0 && (
						<>
							<strong>Attachments: </strong>
							{attachments.map((attachment, index) => (
								<>
									<span key={index} onClick={() => viewAttachment(attachment)}>
										<a href="#"> {attachment.name}</a>
									</span>
									&nbsp;&nbsp;
								</>
							))}
						</>
					)}
				</Grid>
			) : (
				<Grid item xs={6}>
					<form
						onSubmit={handleSubmit(handleResolveClick)}
						style={{ width: "100%" }}>
						<Grid item xs={12}>
							<TextField
								size="small"
								name="txtResolveReason"
								inputRef={register({ required: true })}
								error={Boolean(errors && errors.txtResolveReason)}
								variant="outlined"
								multiline
								minRows={3}
								maxRows={3}
								style={{ width: "100%" }}
								value={rfiData.closing_comment ?? ""}
								onChange={(e) =>
									setRfiData({ ...rfiData, closing_comment: e.target.value })
								}
							/>
						</Grid>
						<Grid item xs={12} style={{ textAlign: "right" }}>
							<Button
								id="Close"
								size="small"
								type="submit"
								variant="contained"
								disabled={saving}
								color="secondary"
								startIcon={saving ? <CircularProgress size={20} /> : <SaveIcon />}>
								{" "}
								Close RFI
							</Button>
						</Grid>
						<Grid item xs={12} style={{ textAlign: "right" }}>
							<TextField
								size="small"
								name="container_file_uploader"
								error={Boolean(errors && errors.container_file_uploader)}
								id="container_file_uploader"
								type="file"
								variant="outlined"
								style={{ width: "99%" }}
								onChange={onFileSelected}
							/>
							<Button
								id="Upload"
								size="small"
								type="button"
								variant="contained"
								disabled={uploading}
								color="primary"
								onClick={uploadFile}
								startIcon={
									uploading ? <CircularProgress size={20} /> : <CloudUpload />
								}>
								{" "}
								Upload Document
							</Button>
						</Grid>
					</form>
				</Grid>
			)}
		</Grid>
	);
}

export default RfiItem;
